import React, { useState, useEffect } from 'react';
import './NurseAvailabilityDisplay.scss';

function formatDate(dateStr) {
	const date = new Date(dateStr);
	if (isNaN(date.getTime())) {
		return dateStr;
	}
	return date.toLocaleDateString('en-GB', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
}

export default function DateTimePicker({
	nurseId,
	availabilityData = {},
	onDateTimeChange,
	selectedNurseId,
	selectedDate,
	selectedTime,
	label = 'Select Date & Time',
	required = false,
}) {
	const [dates, setDates] = useState([]);
	const [dateStartIndex, setDateStartIndex] = useState(0);

	const [timeStartIndex, setTimeStartIndex] = useState(0);
	useEffect(() => {
		const newDates = Object.keys(availabilityData);
		setDates(newDates);
		setDateStartIndex(0);
		setTimeStartIndex(0);
	}, [availabilityData]);

	const handleSelectDate = (date) => {
		onDateTimeChange({ nurseId, date, time: '' });
		setTimeStartIndex(0);
	};

	const handleSelectTime = (time) => {
		onDateTimeChange({ nurseId, date: selectedDate || '', time });
	};

	const handleDateNext = () => setDateStartIndex((prev) => prev + 3);
	const handleDatePrev = () => setDateStartIndex((prev) => prev - 3);

	const handleTimeNext = () => setTimeStartIndex((prev) => prev + 4);
	const handleTimePrev = () => setTimeStartIndex((prev) => prev - 4);

	const isThisNurseSelected = nurseId === selectedNurseId;

	const visibleDates = dates.slice(dateStartIndex, dateStartIndex + 3);

	let timeSlots = [];
	let businessOpen = false;
	if (isThisNurseSelected && selectedDate && availabilityData[selectedDate]) {
		businessOpen = availabilityData[selectedDate].businessOpen;
		timeSlots = availabilityData[selectedDate].availableTimeSlots || [];
	}
	const visibleTimeSlots = timeSlots.slice(timeStartIndex, timeStartIndex + 4);

	return (
		<div className="dateTimePickerWrapper">
			{label && (
				<label className="dtpLabel">
					<b>{label}</b>
					{required && <span className="requiredStar">*</span>}
				</label>
			)}

			{dates.length === 0 ? (
				<div className="dtpNoData">No available dates.</div>
			) : (
				<div className="dateCarouselContainer">
					<button
						type="button"
						className="dateNavBtn left"
						onClick={handleDatePrev}
						disabled={dateStartIndex === 0}
					>
						&lt;
					</button>

					<div className="dateCards">
						{visibleDates.map((date) => {
							const isOpen = availabilityData[date].businessOpen;
							const isHighlighted = isThisNurseSelected && selectedDate === date;
							return (
								<button
									key={date}
									type="button"
									className={`dateCard ${isHighlighted ? 'selected' : ''}`}
									onClick={() => handleSelectDate(date)}
									disabled={!isOpen}
								>
									{formatDate(date)}
								</button>
							);
						})}
					</div>

					<button
						type="button"
						className="dateNavBtn right"
						onClick={handleDateNext}
						disabled={dateStartIndex + 3 >= dates.length}
					>
						&gt;
					</button>
				</div>
			)}

			{isThisNurseSelected && selectedDate && (
				<div style={{ marginTop: '1rem' }}>
					{!businessOpen && (
						<div className="dtpNoData" style={{ color: 'red' }}>
							Sorry, no availability on {formatDate(selectedDate)}.
						</div>
					)}

					{businessOpen && timeSlots.length === 0 && (
						<div className="dtpNoData" style={{ color: 'red' }}>
							No time slots available on {formatDate(selectedDate)}.
						</div>
					)}

					{businessOpen && timeSlots.length > 0 && (
						<div className="timeCarouselContainer">
							<button
								type="button"
								className="timeNavBtn left"
								onClick={handleTimePrev}
								disabled={timeStartIndex === 0}
							>
								&lt;
							</button>
							<div className="timeCards">
								{visibleTimeSlots.map((tSlot) => {
									const isHighlighted =
										isThisNurseSelected && selectedDate && selectedTime === tSlot;
									return (
										<button
											key={tSlot}
											type="button"
											className={`timeCard ${isHighlighted ? 'selected' : ''}`}
											onClick={() => handleSelectTime(tSlot)}
										>
											{tSlot}
										</button>
									);
								})}
							</div>
							<button
								type="button"
								className="timeNavBtn right"
								onClick={handleTimeNext}
								disabled={timeStartIndex + 4 >= timeSlots.length}
							>
								&gt;
							</button>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
